import React, { useState, useRef } from 'react';
import styles from './HowItWorks.module.css';
import Footer from '../../Desktop/Components/Footer';

const videoPaths = [
  '/no swiping.mp4',
  '/privacy first.mp4',
  '/more trust.mp4',
  '/social matching mechanism.mp4',
  '/dont stop at dating.mp4',
  '/jump into it now.mp4',
];

const sectionContent = [
  {
    title: 'No swiping',
    subtitle: "Match by liking each other's posts"
  },
  {
    title: 'Privacy first',
    subtitle: 'Photos featuring faces are only allowed as Match Photos'
  },
  {
    title: 'More trust',
    subtitle: 'Enabled by the user-based trust rating system & friends opinions'
  },
  {
    title: 'More connected',
    subtitle: 'Feels like a social network, not a catalogue '
  },
  {
    title: 'Dont stop at dating',
    subtitle: 'CrossedPaths is built to create all kinds of connections'
  },
  {
    title: "Jump into it now",
    subtitle: "Just tell us about yourself and who you’d like to meet"
  }
];

const placeholderImage = './video-placeholder.png';

const HowItWorks = ({ onNavigate }) => {
  const [fullscreenIndex, setFullscreenIndex] = useState(null);

  const handleFullScreen = (index) => {
    setFullscreenIndex(index);
  };

  const handleCloseFullScreen = () => {
    setFullscreenIndex(null);
  };

  return (
    <div className={styles.howItWorksContainer}>
      {videoPaths.map((videoPath, index) => {
        const { title, subtitle } = sectionContent[index];

        return (
          <section key={index} className={`${styles.section} ${index % 2 === 1 ? styles.rightVideo : styles.leftVideo}`}>
            <div className={styles.textContainer}>
              <h2 className={styles.orangeTitle}>{title}</h2>
              <p className={styles.blackSubtitle}>{subtitle}</p>
            </div>
            <div className={styles.mediaContainer}>
              <video
                className={`${styles.video} ${fullscreenIndex === index ? styles.fullscreenVideo : ''}`}
                autoPlay
                muted
                loop
                playsInline
                onClick={() => handleFullScreen(index)}
              >
                <source src={videoPath} type="video/mp4" />
                Your browser does not support the video tag.
                </video>
              {fullscreenIndex === index && (
                <>
                  <div className={styles.fullscreenOverlay} onClick={handleCloseFullScreen} />
                  <button className={styles.closeButton} onClick={handleCloseFullScreen}>X</button>
                </>
              )}
              <img src={placeholderImage} alt="Placeholder" className={styles.placeholderImage} />
            </div>
          </section>
        );
      })}
      <Footer onNavigate={onNavigate} />
    </div>
  );
};

export default HowItWorks;
